<template>
  <div>
    <div>
      <svg id="toolId" viewBox="0,0,230,480">
      </svg>
    </div>

  </div>
</template>

<script>
import * as d3 from 'd3'
export default {
  name: 'toolBar',
  props: {
    toolHeight: {
      default: '85vh',
      type: String
    }
  },
  data() {
    return {
      Margin: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20
      },
      Rectangle: {
        height: 20,
        width: 30
      },
      nodes: [
        { name: '开始节点', icon: '', disabled: false },
        { name: '结束节点', icon: '', disabled: false },
        { name: '普通节点', icon: '', disabled: false },
        { name: '连接线', icon: '', disabled: false }
      ]
    }
  },
  mounted() {
    this.initToolBar()
  },
  methods: {
    initToolBar() {
      const svg = d3.select('#toolId')
      const g = svg.append('g')
      //添加节点
      g.append('rect')
        .attr('id', 'start')
        .attr('height', this.Rectangle.height)
        .attr('width', this.Rectangle.width)
        .attr('fill', '#1BA1E2')
        .attr('transform', `translate(${this.Margin.left}, ${this.Margin.top})`)
      g.append('text')
        .attr('x', this.Rectangle.width + (this.Margin.left * 2))
        .attr('y', this.Margin.top + (this.Rectangle.height * 0.75))
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('text-anchor', 'start')
        .text('节点')

      //添加开始节点
      g.append('circle')
        .attr('r', this.Rectangle.width / 2)
        .attr('cx', this.Margin.left + this.Rectangle.width / 2)
        .attr('cy', this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width / 2)
        .attr('fill', 'green')
      g.append('text')
        .attr('x', this.Margin.left + this.Rectangle.width / 4)
        .attr('y', this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width * 0.65)
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('fill', '#fff')
        .attr('text-anchor', 'start')
        .text('始')
      g.append('text')
        .attr('x', this.Margin.left * 2 + this.Rectangle.width)
        .attr('y', this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width * 0.65)
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('text-anchor', 'start')
        .text('开始')

      //添加结束节点
      g.append('circle')
        .attr('r', this.Rectangle.width / 2)
        .attr('cx', this.Margin.left + this.Rectangle.width / 2)
        .attr('cy', this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.5)
        .attr('fill', '#D80073')
      g.append('text')
        .attr('x', this.Margin.left + this.Rectangle.width / 4)
        .attr('y', this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.65)
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('fill', '#fff')
        .attr('text-anchor', 'start')
        .text('止')
      g.append('text')
        .attr('x', this.Margin.left * 2 + this.Rectangle.width)
        .attr('y', this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.65)
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('text-anchor', 'start')
        .text('结束')


      //添加线段

      //添加defs标签
      var defs = svg.append('defs')
      //添加marker标签及其属性
      var arrowMarker = defs.append('marker')
        .attr('id', 'arrow')
        .attr('markerUnits', 'strokeWidth')
        .attr('markerWidth', 8)
        .attr('markerHeight', 8)
        .attr('viewBox', '0 0 8')
        .attr('refX', 4)
        .attr('refY', 4)
        .attr('orient', 'auto')
      //绘制直线箭头
      var arrow_path = 'M2,2 L6,4 L2,6 L4,4 L2,2'
      arrowMarker.append('path')
        .attr('d', arrow_path)
        .attr('fill', '#000')
      var data = [[this.Margin.left, this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.5],
        [this.Margin.left + this.Rectangle.width, this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.5]]
      var lineGenerator = d3.line()
      var pathString = lineGenerator(data)
      // d3.select('path').attr('d', pathString)

      g.append('path')
        .attr('d', pathString)
        .attr('stroke', 'steelblue')
        .attr('stroke-width', 3)
        .attr('fill', 'none')
        .attr('marker-start', 'url(#circle)')
        .attr('marker-end', 'url(#arrow)')

      g.append('text')
        .attr('x', this.Margin.left * 2 + this.Rectangle.width)
        .attr('y', this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.75)
        .attr('font-family', 'Verdana')
        .attr('font-size', '16')
        .attr('text-anchor', 'start')
        .text('连线')
      let clone = ''
      var drag = d3.drag()
        .on('start', toDraged) // 拖动开始，触发一次
        .on('drag', draged) // 拖动中，触发多次
        .on('end', () => {}) // 拖动结束，触发一次

      function toDraged() {
        clone = d3.select(this)
          .clone(true)
      }
      function draged() {
        clone
          .attr('x', d3.event.x)
          .attr('y', d3.event.y)
      }

      g.selectAll('rect')
        .call(drag)
    }
  }
}
</script>

<style scoped>

</style>
